import { AfterViewInit, Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrencyPipe } from '@angular/common';

import { PATH } from '@app/constants';
import { ProjectPurchaseInfo } from '@interfaces/app';
import { ModalCustomOptions, OTP_ACTION } from '@app/models';
import { GpsV2Service, ProjectsService, UserService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { catchError, EMPTY, forkJoin, map, Subscription, switchMap, take } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageTitleService } from '@app/services/page-title/page-title.service';
import { AnalyticsService } from '@app/services/analytics/analytics.service';
import { SingularService } from 'src/infra/analytics/singular/singular.service';
import { TikTokContentType, TikTokService } from 'src/infra/analytics/tiktok/tiktok.service';

@Component({
   templateUrl: './project-purchase.component.html',
   styleUrls: ['./project-purchase.component.scss']
})
export class ProjectPurchaseComponent implements OnInit, AfterViewInit, OnDestroy {

   public readonly urlBaseS3 = 'https://static.monific.com/assets/projects-images/';


   sub: Subscription;
   shellContainer: Element;

   project: ProjectPurchaseInfo;
   userBalance = 0;

   totalAfterPurchase = 0;

   totalToPay = 0;

   estimatedPerformance = 0;
   estimatedAppreciation = 0;
   estimatedTotal = 0;

   otpMethodActual: any;
   modalOTPConf: any;

   partsForm: FormGroup;
   selectedAmountByForm = 1;

   infoFunctionAutomated: any;

   /** Discount immediately */
   discountImmediately: number = 0;

   /** Participaciones activas del proyecto hasta el momento */
   partsActual: number = 0;

   /** Participaciones finales libres para comrpar por usuario */
   totalFreePerUser: number = 0;

   actualState: string;

   userWithoutPurchaseLimit = false;

   showInfoParts: boolean = false;

   constructor(
      private render: Renderer2,
      private userServ: UserService,
      private currency: CurrencyPipe,
      private activatedRoute: ActivatedRoute,
      private router: Router,
      private modalServ: ModalService,
      private projectServ: ProjectsService,
      private toastr: ToastrService,
      private gpsServ: GpsV2Service,
      private fb: FormBuilder,
      private modal: ModalService,
      private readonly pageTitleService: PageTitleService,
      private analyticsService: AnalyticsService,
      private singularServ: SingularService,
      private readonly tiktokServ: TikTokService
   ) { }

   ngOnInit(): void {
      /** Cargar OTP Method correcto */


      this.userServ.getUserInf(true).subscribe(r => {
         this.userWithoutPurchaseLimit = r?.noPurchaseLimit;
         this.otpMethodActual = r.otpMethod === 'sms' ? 'SMS' : 'a tu correo electrónico';
         this.modalOTPConf = {
            header: 'Compra de participaciones',
            title: 'Verificación de compra',
            message: `Ingresa el <span class="cl-primary-7">Token</span> que ha sido enviado ${this.otpMethodActual}`
         };
      })

      //this.userServ.getUserInf(true).subscribe(r => { r.otpMethod.toString() === 'sms' ? 'SMS' : 'a tu correo electrónico'}})
      this.activatedRoute.params.subscribe(params => {
         if (params.pid) {
            this.getUserInfo(params.pid);
         } else {
            this.router.navigate([PATH.ROUTE_RESALE_MARKET]);
         }
      });

      setTimeout(() => {
         this.project.imagesNewProject = this.project.image || this.project.gallery || this.project.imagesNewProject;
      }, 600)

   }

   showInfo() {
      this.showInfoParts = !this.showInfoParts;
   }

   buildImageUrl(dev: any, urlBaseS3: string): string {
      let basePath = dev?.gallery[0] || dev?.image || dev.imagesNewProject ? dev?.pid : dev?.baseProject;
      let imageUrl = dev?.gallery[0] || dev?.image;

      if (!imageUrl) {
        return '';
      }

      let fullUrl = urlBaseS3 + basePath + '/' + imageUrl;
      let urlParts = fullUrl.split("https://static.monific.com/assets/");
      if (urlParts.length > 2) {
        fullUrl = "https://static.monific.com/assets/" + urlParts.pop();
      }

      return fullUrl;
    }

   splitURL(url: string) {
      // /let fullUrl = urlBaseS3 + basePath + '/' + imageUrl;
      // /let urlParts = fullUrl.split("https://static.monific.com/assets/");
      // /if (urlParts.length > 2) {
      // /  fullUrl = "https://static.monific.com/assets/" + urlParts.pop();
      // /}
   }

   getMaxParticipationsToBuy(
      data: {
         purchaseLimit: boolean,
         availableParts: number,
         devPartsLimitPerUser: number,
         userParts: number
      }): number {
         // Si el usuario no tiene límite de compra, se le permite comprar todas las participaciones disponibles en el proyecto
      if (!data.purchaseLimit) {
         return data.availableParts;
      }
      // Si el usuario tiene límite de compra, se le permite comprar hasta el límite de participaciones disponibles en el proyecto menos las que ya tiene
      const maxParts = data.availableParts > data.devPartsLimitPerUser - data.userParts ? data.devPartsLimitPerUser - data.userParts : data.availableParts;

      return maxParts < 1 ? 0 : maxParts;
   }

   getUserInfo(pid: string, reloadUserInfo = false) {
      forkJoin({
         user: this.userServ.getUserInf(reloadUserInfo),
         dev: this.projectServ.getProjectInfoToPurchase(pid),
         infoStatus: this.projectServ.getStatusMovements()
      }).subscribe(res => {

         setTimeout(() => {
            this.project.image = this.project?.image || this.project?.imagesNewProject || this.project?.gallery?.[0];
         }, 500)


         if (res.dev.free) {
            this.project = res.dev;
            this.project.pid = pid;
            this.actualState = res.dev.actualState;

            this.pageTitleService.setTitle(`${this.project.name} | Invertir`);


            const specificProject = res.user?.participations?.find(part => part.pid === this.project?.pid);
            this.partsActual = specificProject?.amount || 0;
            this.userWithoutPurchaseLimit = res.user?.noPurchaseLimit;
            const data = { purchaseLimit: !this.userWithoutPurchaseLimit, availableParts: this.project.free, devPartsLimitPerUser: this.project.limit, userParts: this.partsActual };
            this.totalFreePerUser = this.getMaxParticipationsToBuy(data);

            this.userBalance = res.user.wallet.balance;
            this.infoFunctionAutomated = res.infoStatus.info;
            this.initForm();
            this.updatePriceByForm();
         } else {
            this.toastr.warning('Proyecto fondeado');
            this.router.navigate([PATH.ROUTE_PROJECTS_MARKET_ACTIVE]);
         }
      });
   }

   /** Inicializar formulario */
   initForm() {
      this.partsForm = this.fb.group({
         partsToBuy: [1, Validators.compose([Validators.min(1), Validators.max(this.totalFreePerUser)])]
      });
      return this.selectedAmountByForm = this.partsForm.get('partsToBuy').value;
   }

   /** Obtener el valor del formulario */
   getValue() {
      return this.selectedAmountByForm = this.partsForm.get('partsToBuy').value;
   }

   /** Incrementar valor y calcular nuevo valor */
   plusAmount() {
      if ((this.selectedAmountByForm + 1) <= this.totalFreePerUser) {
         const a = this.selectedAmountByForm += 1;
         this.partsForm.controls.partsToBuy.setValue(a);
         this.updatePriceByForm();
      }
   }

   /** Disminuir valor y calcular nuevo valor */
   minusAmount() {
      if ((this.selectedAmountByForm - 1) >= 1) {
         const b = this.selectedAmountByForm -= 1;
         this.partsForm.controls.partsToBuy.setValue(b);
         this.updatePriceByForm();
      }
   }

   /** Actualizar precio de forma automatica dependiendo el valor */
   updatePriceByForm() {
      if (this.selectedAmountByForm > this.totalFreePerUser) {
         this.selectedAmountByForm = this.totalFreePerUser;
         this.partsForm.controls.partsToBuy.setValue(this.selectedAmountByForm);
      }

      this.discountImmediately = (1000 * this.project?.discount) * this.selectedAmountByForm;

      this.totalToPay = this.selectedAmountByForm * this.project.partValue;
      this.estimatedPerformance = ((this.project.performance) * 10) * this.selectedAmountByForm;
      this.estimatedAppreciation = ((this.project.appreciation || 0) * 10) * this.selectedAmountByForm;
      if (this?.project?.actualState == 'residential') {
         this.estimatedTotal = this.estimatedAppreciation;
      } else {
         this.estimatedTotal = this.estimatedPerformance + this.estimatedAppreciation || 0;
      }
      this.totalAfterPurchase = this.userBalance - this.totalToPay;
   }

   /** Función para actualizar el precio en tiempo real */
   updateInRealTimeKeyPress(parts: any) {
      this.selectedAmountByForm = parseInt(parts?.value) || 0;
      this.updatePriceByForm();
   }

   ngAfterViewInit(): void {
      //this.shellContainer = document.getElementsByClassName('content-shell')[0];
      //this.render.addClass(this.shellContainer, 'p-0');
   }

   next() {
      if (this.selectedAmountByForm) {
         if (this.selectedAmountByForm <= this.project.free && this.selectedAmountByForm <= this.totalFreePerUser) {
            this.analyticsService.pushEvent('likely_purchase_participation', {project: this.project.name,amount: this.selectedAmountByForm,total: this.totalToPay,status: 'OPEN_MODAL_BUTTON'});
   
            const coords = this.gpsServ.getCoordinatesFromLocalStorage();
   
            if (coords) {
               this.openConfirmationModal();
            } else {
               this.sub = this.gpsServ.defineGPS().subscribe({
                  next: defined => {
                     if (defined) {
                        this.openConfirmationModal();
                     } else {
                        this.toastr.error('No se pudo obtener la ubicación. Intenta nuevamente.');
                     }
                  }
               });
            }
         } else {
            this.analyticsService.pushEvent('likely_purchase_participation', {project: this.project.name,amount: this.selectedAmountByForm,total: this.totalToPay,status: 'INSUFFICIENT_PARTICIPATIONS'});
            this.toastr.warning('Participaciones insuficientes');
         }
      } else {
         this.analyticsService.pushEvent('likely_purchase_participation', {project: this.project.name,amount: this.selectedAmountByForm,total: this.totalToPay,status: 'NO_PARTICIPATIONS_SELECTED'});
         this.toastr.warning('Debes seleccionar al menos 1 participación');
      }
   }
   

   openConfirmationModal() {
      const conf: ModalCustomOptions = {
         header: 'Compra de participaciones',
         title: '¿Seguro de continuar?',
         message: `Se comprarán <span class="cl-primary-7">${this.selectedAmountByForm} ${this.selectedAmountByForm > 1 ? 'participaciones' : 'participación'}</span>
      de <span class="cl-primary-7">${this.project.name}</span> por un costo total de ${this.currency.transform(this.totalToPay, '$')}`,
         buttonText: 'Continuar',
         cancelText: 'Cancelar'
      };

      const m = this.modalServ.modalCustom(conf);

      m.beforeClosed().subscribe(accept => {
         // Si responde en cancelar o cierra el modal
         if (accept) {
            this.analyticsService.pushEvent('likely_purchase_participation', { project: this.project.name, amount: this.selectedAmountByForm, total: this.totalToPay, status: 'ACCEPTED' });
            if (this.userBalance >= this.totalToPay) {
               if (this.userServ.otpMethod === 'auth-app') {
                  this.openMFA();
               } else {
                  // Si no, manda otp para compra de participaciones
                  this.modalServ.sendAndOpenModalOTP(OTP_ACTION.BUY, this.modalOTPConf).subscribe(otp =>
                     this.purchaseModalOption(otp, this.selectedAmountByForm, this.project.partValue));
               }
            } else {
               this.analyticsService.pushEvent('likely_purchase_participation', { project: this.project.name, amount: this.selectedAmountByForm, total: this.totalToPay, status: 'INSUFFICIENT_BALANCE' });
               const balanceNeeded = this.totalToPay - this.userBalance;
               const modal = this.modal.openModalEnoughBalance(balanceNeeded, this.selectedAmountByForm, this.project.name);

               modal.afterClosed().subscribe(reload => {
                  if (reload) {
                     this.getUserInfo(this.project.pid, true);
                  }
               });
            }
         } else {
            this.analyticsService.pushEvent('likely_purchase_participation', { project: this.project.name, amount: this.selectedAmountByForm, total: this.totalToPay, status: 'REJECTED' })
         }

      });
   }

   /** Abrir modal para ingresar código de MultiFactor de Autenticación | Authenticator */
   private openMFA() {
      const mfa = this.modalServ.openMFA();
      this.analyticsService.pushEvent('likely_purchase_participation', { project: this.project.name, amount: this.selectedAmountByForm, total: this.totalToPay, status: 'OPEN_MFA' });
      mfa.beforeClosed().subscribe(token => {
         if (token) this.purchase(this.selectedAmountByForm, this.project.partValue, token, true);
      });
   }

   /** Opciones para respuesta de OTP */
   private purchaseModalOption(otp: string, amount: number, value: number) {
      if (otp) {
         this.analyticsService.pushEvent('likely_purchase_participation', { project: this.project.name, amount: this.selectedAmountByForm, total: this.totalToPay, status: 'OPEN_WITH_OTP' });
         // Si se ingresó 5 digitos del token sigue la comprobación del token para la operación
         this.purchase(amount, value, otp);
      }
   }

   /** Acción para compra de participaciones */
   private purchase(amount: number, value: number, otp: string, mfa?: boolean) {
      this.projectServ.purchaseParticipations({amount, pid: this.project.pid, otp, mfa}).subscribe({
         next: () => {
            this.analyticsService.pushEvent('investment_made', { project: this.project.name, amount: this.selectedAmountByForm, total: this.totalToPay, value: this.totalToPay, currency: 'MXN'  });
            const m = this.modalServ.modalCustom({
               img: 'https://static.monific.com/assets/assets-app/img/icon/img/purchase_success.svg',
               title: '¡Felicidades!',
               message: `Eres dueño de ${amount} ${amount === 1 ? 'participación' : 'participaciones'} de la propiedad ${this.project.name}
             por un total de ${this.currency.transform(this.totalToPay, '$')}.`,
               buttonText: 'Continuar'
            });

            m.beforeClosed().subscribe(() => this.router.navigate([PATH.ROUTE_DASHBOARD_HOME]))
         },
         error: err => {
            if (mfa) {
               this.analyticsService.pushEvent('likely_purchase_participation', { project: this.project.name, amount: this.selectedAmountByForm, total: this.totalToPay, status: 'OPEN_WITH_MFA' });
               this.openMFA();
            } else {
               this.analyticsService.pushEvent('likely_purchase_participation', { project: this.project.name, amount: this.selectedAmountByForm, total: this.totalToPay, status: 'RETRY_MODAL_OTP' });
               // Se vuelve a abrir el modal de retiro
               this.modalServ.openModalOTP(this.modalOTPConf).subscribe(otp => this.purchaseModalOption(otp, amount, value));
            }
         }
      });
   }

   ngOnDestroy(): void {
      this.analyticsService.pushEvent('likely_purchase_participation', { project: this.project.name, amount: this.selectedAmountByForm, total: this.totalToPay, status: 'CLOSED' });
      this.render.removeClass(this.shellContainer, 'p-0');
   }
}
